import { useFormikContext } from "formik";
import { ButtonComp } from "../../../../components";
import { toast } from "react-hot-toast";

export const personal_details = {
  first_name: "",
  last_name: "",
  occupation: "",
  occupation_id: "",
  dob: "",
  marital_id: "",
  next_of_kin_name: "",
  next_of_kin_phone: "",
  relationship_status_id: "",
  gender_id: "",
  title_id: "",
  email: "",
  address: "",
  phone: "",
};

export const FormikCheckBtn = ({
  formikFields,
  isDisabled = false,
  onBtnClick,
}) => {
  const { errors, values, touched, setTouched, validateForm } = useFormikContext();
  
  // Optional fields that should be skipped from required validation
  const optionalFields = ['email', 'other_name'];
  
  return (
    <ButtonComp
      disabled={isDisabled}
      btnText={"Proceed"}
      onClick={async () => {
        // Mark all fields as touched to trigger validation
        const fieldsToTouch = {};
        formikFields.forEach(key => {
          if (!touched[key]) {
            fieldsToTouch[key] = true;
          }
        });
        if (Object.keys(fieldsToTouch).length > 0) {
          setTouched(fieldsToTouch);
        }
        
        // Trigger validation for all fields
        const validationErrors = await validateForm();
        
        // Only check for validation errors in the fields we're validating (ignore other fields like payment_method)
        if (validationErrors && Object.keys(validationErrors).length > 0) {
          // Find the first error from the fields we're checking (only validate fields in formikFields)
          for (let index = 0; index < formikFields.length; index++) {
            const key = formikFields[index];
            // Skip optional fields
            if (optionalFields.includes(key)) {
              continue;
            }
            // Check if this field has a validation error
            if (validationErrors[key]) {
              return toast.error(validationErrors[key], {
                duration: 3000,
              });
            }
          }
        }
        
        // If no validation errors in the fields we're checking, proceed
        onBtnClick();
      }}
      btnClassName={"w-100 bg-primary1 py-2 text-white border-0 rounded"}
      type={"button"}
    />
  );
};

export default FormikCheckBtn;
